import Cookies from 'js-cookie';

export default function () {
    function setCookie() {
        let CookieMenuSet = '';

        document.querySelectorAll('#menu > ul > li:not(.active)').forEach(li => {
            CookieMenuSet += li.getAttribute('id') + '|';
        });

        Cookies.set('cookies-menu', CookieMenuSet, { expires: 7, path: '/' });
    }

    let sidebarCollapsed = Cookies.get('sidebar-collapsing') == '1' ? true : false;

    function cookieSidebar() {
        sidebarCollapsed = !sidebarCollapsed;
        Cookies.set('sidebar-collapsing', sidebarCollapsed ? '1' : '0', { expires: 365, path: '/' });
    }

    const userNav = document.querySelector('.user-nav');

    if (userNav) {
        userNav.addEventListener('click', function () {
            userNav.classList.toggle('active');
        });
    }

    document.querySelectorAll('#menu > ul > li > span').forEach(span => {
        span.addEventListener('click', function () {
            if (sidebarCollapsed) {
                [...span.closest('ul').children].filter(child => span.parentElement !== child).forEach(li => {
                    li.classList.remove('active-collapsed');
                });
                span.parentElement.classList.toggle('active-collapsed');
            } else {
                span.parentElement.classList.toggle('active');
                span.parentElement.classList.remove('instant');
                setCookie();
            }
        });
    });

    if (sidebarCollapsed) {
        document.querySelector('main .inner').classList.add('collapsed');
    }

    const collapseButton = document.querySelector('.sidebarCollapseButton');

    if (collapseButton) {
        collapseButton.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('main .inner').classList.toggle('collapsed');
            document.querySelectorAll('#menu > ul > li').forEach(li => li.classList.remove('active-collapsed'));
            cookieSidebar();
        });
    }
}